
import React, { useEffect , useState } from 'react';
import { withRouter } from 'react-router-dom';
import getJwt from './getJwt';

function Auth(props){
  const [state, setState] = useState({
      Authenticated: false
  })

  useEffect(()=>{
    const { history } = props;
    const jwt = getJwt();
    if (!jwt) {
      history.push('/');
    }
     else {
        setState({ Authenticated: true });
    }
  },[])

    const { children } = props;
    const { Authenticated } = state;
    console.log(Authenticated);
    if (Authenticated === false) {
      return (
        <div className="w-100 text-center"></div>
      );
    }
    return (
      <div>
        {children}
      </div>
    );
}

export default withRouter(Auth);